export default __webpack_public_path__ + "static/media/inputlogo.b8e326e8.svg";